<div class="jepto-slide-toggle-host">
	<div
		[class]="cssClasses.join(' ')"
		[attr.aria-disabled]="isDisabled"
		[attr.data-testid]="testId()"
	>
		<!-- Hidden input for accessibility and form integration -->
		<input
			#inputElement
			type="checkbox"
			[id]="toggleId + '-input'"
			[checked]="isChecked"
			[disabled]="isDisabled"
			[required]="required()"
			[name]="name()"
			[value]="value()"
			[tabindex]="tabIndex()"
			[attr.aria-label]="ariaLabel() || null"
			[attr.aria-labelledby]="ariaLabelledby() || null"
			[attr.aria-describedby]="ariaDescribedby() || null"
			class="jepto-slide-toggle__input"
			(change)="onInputChange($event)"
			(blur)="onBlur()"
		/>

		<div
			class="jepto-slide-toggle__track-host"
			[matTooltip]="resolvedTooltip() ?? ''"
			[matTooltipDisabled]="!resolvedTooltip()"
			[matTooltipPosition]="tooltipPosition()"
		>
			<div class="jepto-slide-toggle__track" (click)="onToggleClick($event)">
				<div class="jepto-slide-toggle__track-bg"></div>
				<div class="jepto-slide-toggle__thumb"></div>
			</div>
		</div>

		<label class="jepto-slide-toggle__label" [attr.for]="toggleId + '-input'">
			<ng-content></ng-content>
		</label>
	</div>
</div>
